import React, { Component } from 'react';
import LoaderLogo from '../Svgs/LoaderLogo'
import { connect } from 'react-redux';
import classnames from 'classnames';
import { getTranslate } from 'react-localize-redux';

import "./PageLoader.css"
class PageLoader extends Component {
    state = {
        TPL: 'compulsoryInsuranceCenter'
    }
    render() {
        const { isLoaded, translate } = this.props
        return (
            <div className={
                classnames("page-loader-wrapper", { 'close-loader': isLoaded }
                )}>
                <div className="page-loader-content">
                    <div className="loader size-1"></div>
                    <div className="loaderLogo">
                        <LoaderLogo />
                    </div>
                    <div className="page-loader-text">
                        <span>
                            {translate(this.state.TPL)}
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isLoaded: state.pageLoad.isLoaded,
    translate: getTranslate(state.locale)
});

export default connect(mapStateToProps)(PageLoader);


// WEBPACK FOOTER //
// ./src/components/PageLoader/PageLoader.js